var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloudservices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6641 60.0143H22.1874C13.6141 60.0009 6.66406 53.3109 6.66406 45.0576C6.66406 36.8043 13.6141 30.1176 22.1874 30.1176C23.4974 24.2443 28.1674 19.4509 34.4374 17.5409C40.704 15.6342 47.624 16.8976 52.584 20.8743C57.544 24.8409 59.7907 30.8976 58.484 36.7709H61.784C64.2499 36.7765 66.6494 37.57 68.6324 39.0355C70.6155 40.5011 72.0783 42.562 72.8074 44.9176M66.664 70.0009L73.3307 63.3343L66.664 56.6676M56.664 56.6676L49.9974 63.3343L56.664 70.0009",
    stroke: "white",
    strokeWidth: 5.58,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudservices);
export default __webpack_public_path__ + "static/media/cloud services.f790f86ab8e446b595273345bfab2ba4.svg";
export { ForwardRef as ReactComponent };